module.exports = __webpack_public_path__ + "b77428727bfe73deb15f586c39248bc7.woff";